import * as $ from 'jquery';
const SDIConstants = {
    access_token: `access_token`,
    localService: `api/Configuration/GetServerURL`,
    localWebAPP: `api/Configuration/GetWebAPPURL`,
    DB: `api/Configuration/GetDB`,
    sessionTimeout: 30, //Minutes,
    quantityRegEX: /^[0-9\b]+$/,
    numberRegEX: /^(?!.*\.{2})[0-9\b.]+$/,
    zipcodeRegEx: /^[0-9]+$/,
    stringRegex: /^[a-zA-Z0-9_-\s\x20 ]+$/,
    CountryCodereg: /^[a-zA-Z]+$/,
    alphanumericRegex: /^[A-Za-z0-9]+$/,
    urlRegex: /\.(jpg|jpeg|png|gif|bmp)$/i,
    urlregexp: /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/,
    SDILoader: `SDILoader`,
    loadMessage: `loaderMessage`, //WW-1231 Loader Message ID -Vishwa S
    tokenExpired: `Token Expired`,
    receiveQty: /^[+-]?\d*\.?\d{0,4}$/,
    emailRegex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    PriceRegex: /^\d{0,5}(\.\d{0,2})?$/,
    assertTagIdRegex: /^[A-Za-z0-9@~`!@#$%^&*()_=+\\\\';:\"\\/?>.<,-{}|]*$/,
    NoOnlyZeroRegex: /^(?!0+$)[0-9]+$/,
    POPriceRegex: /^(?!0$)(?:\d{1,10}|\d{1,10}\.\d{0,5})$/,
    availablePages: [
        {
            pageName: "Home", pageTitle: "Home", pageURL: "/homepage"
        },
        {
            pageName: "ShoppingCart", pageTitle: "Shopping Cart", pageURL: "/shoppingcart"
        },
        {
            pageName: "Favorites", pageTitle: "Favorites", pageURL: "/favorites"
        },
        {
            pageName: "FavoriteOrder", pageTitle: "Favorite Orders", pageURL: "/favorder"
        },
        {
            pageName: "Notifications", pageTitle: "UserNotifications", pageURL: "/usernotification"
        },
        {
            pageName: "NonCatalog", pageTitle: "Non-Catalog Request", pageURL: "/rfqentry"
        },
        {
            pageName: "Punchout", pageTitle: "Punchout Catalog", pageURL: "/punchout"
        },
        {
            pageName: "ShopRedirect", pageTitle: "Shop Redirect", pageURL: "/shopredirect"
        },
        {
            pageName: "OrderApproval", pageTitle: "Need Approve", pageURL: "/needapprove"
        },
        {
            pageName: "WaitingRequestorApproval", pageTitle: "Need Quote", pageURL: "/needquote"
        },
        {
            pageName: "RequestorApproval", pageTitle: "Approve Quote", pageURL: "/approvequote"
        },
        {
            pageName: "UserProfile", pageTitle: "User Profile", pageURL: "/profile"
        },
        {
            pageName: "ItemDetail", pageTitle: "Item Detail", pageURL: "/itemdetailnew"
        },
        {
            pageName: "SearchResults", pageTitle: "Search Results", pageURL: "/searchresults"
        },
        {
            pageName: "OrderStatus", pageTitle: "Order Status", pageURL: "/orderstatus2"
        },
        {
            pageName: "UnderConstruction", pageTitle: "Under Construction", pageURL: "/underconstruction"
        },
        {
            pageName: "AccessDenied", pageTitle: "Access Denied", pageURL: "/accessdenied"
        },
        {
            pageName: "TestPage", pageTitle: "Test Page", pageURL: "/testpage"
        },
        {
            pageName: "SessionTimeOut", pageTitle: "Session Timeout", pageURL: "/sessiontimeout"
        },
        {
            pageName: "SupplierCallIn", pageTitle: "Supplier Call-In", pageURL: "/supplierorderentry"
        },
        {
            pageName: "Pickup", pageTitle: "Picking Assign To", pageURL: "/pickingassignto"
        },
        {
            //[9/26/22], Bug - 2696 - To make the receive items panel based on the previlege, Dhevanesam R
            pageName: "ReceiveItems", pageTitle: "Receive Items", pageURL: "/receiving"
        },
        {
            pageName: "CycleCount", pageTitle: "CycleCount", pageURL: "/cyclecount"
        },
        {
            pageName: "Reconciliation", pageTitle: "Reconciliation", pageURL: "/cyclecountrecon"
        },
        {
            pageName: "LabelByLocation", pageTitle: "Labels by Location", pageURL: "/labelsbyloc"

        },
        {
            pageName: "Replen", pageTitle: "Replen Review", pageURL: "/replen"
        },
        {
            pageName: "StockvalueReport", pageTitle: "Stock Value Report", pageURL: "/stockvaluerpt"
        },
        {
            pageName: "InsiteonlineRMA", pageTitle: "Return to Inventory", pageURL: "/insiteonlinerma"
        },
        {
            pageName: "CCReport", pageTitle: "Cycle Count Analysis", pageURL: "/cyclecntreconrpt"
        },
        {
            pageName: "StockIssueReport", pageTitle: "Stock Issue Report", pageURL: "/insiteonlinestkis"
        },
        {
            pageName: "BinLabelPrint", pageTitle: "Bin Label Printing", pageURL: "/BinLabelPrinting"
        },
        {
            pageName: "ProductReplenishment", pageTitle: "Product Replenishment", pageURL: "/orderitems"
        },
        {
            pageName: "KenstanForm", pageTitle: "Kenstan Form", pageURL: "/Kenstanform"
        }
        ,
        {
            pageName: "AddStockItems", pageTitle: "Add Stock Items", pageURL: "/addstockitems"
        }
        ,
        {
            pageName: "ASNApproval", pageTitle: "SDI ASN Entry", pageURL: "/SDIAsnEntry"
        },
        {
            pageName: "POWorkbench", pageTitle: "PO Workbench", pageURL: "/expedite"
        },
        {
            pageName: "ExpressPutAway", pageTitle: "Express PutAway", pageURL: "/ExpressPutawayLocation"
        },

        {
            pageName: "ManualStockAdjustment", pageTitle: "Manual Stock Adjustment", pageURL: "/ManualStockAdj"
        },
        /*[2/24/22, PC_DP_04, Priyanka.D]*/
        {
            pageName: "DefaultPutAwayLocations", pageTitle: "Default PutAway Locations", pageURL: "/PutawayPickingLocations"
        },
        //[1/20/22, PC_IH_05, WW-320, Dhevanesam R]
        {
            pageName: "ItemHolds", pageTitle: "ItemHolds", pageURL: "/HoldItemList"
        },
        //BTB_PC_04 - Deepthi N H
        {
            pageName: "BinToBinTransfer", pageTitle: "Bin To Bin Transfer", pageURL: "/BinToBinTransfer"
        },
        /*[01/30/22, PC_EF_03, Priyanka.D]*/
        {
            pageName: "EnersysForm", pageTitle: "Enersys Form", pageURL: "/enersysform"
        },
        /* RRR_PC_01 */
        {
            pageName: "ReceivingReport", pageTitle: "Receiving Report", pageURL: "/rcvrpt"
        },
        {
            pageName: "TransactionReport", pageTitle: "Transaction Report", pageURL: "/transselect"
        },
        {
            pageName: "FedexShipping", pageTitle: "Fedex Shipping", pageURL: "/fedexshipping"
        },
        {
            pageName: "OpenPOReport", pageTitle: "OpenPO Report", pageURL: "/postatus"
        },
        {
            pageName: "RTV", pageTitle: "RTV", pageURL: "/rtv"
        },
        {
            pageName: "ReprintPackingSlipsComponent", pageTitle: "ReprintPackingSlipsComponent", pageURL: "/reprintPackN1"
        },
        {
            pageName: "MaterialStorageLoc", pageTitle: "MaterialStorageLoc", pageURL: "/MaterialStorageLoc"
        },
        /*[03/28/22, PC_DF_03, Priyanka.D]*/
        {
            pageName: "DoorFormComponent", pageTitle: "Door Form", pageURL: "/DoorForm"
        },
        {
            pageName: "RefSiteMaintenanceComponent", pageTitle: "ReferenceSite Maintenance", pageURL: "/refsitemaintenance"
        },
        {
            pageName: "STKIssuesCart", pageTitle: "Stock Issue", pageURL: "/STKIssuesCart"
        },

        {
            pageName: "LoadStageError", pageTitle: "Load Stage And Putaway", pageURL: "/loadstageandputaway"
        },

        {
            pageName: "SupplierOrderEntry", pageTitle: "Walk-In", pageURL: "/AdvancedSupplierOrderEntry"
        },
        {
            pageName: "SupplierSuggestion", pageTitle: "SupplierSuggestion", pageURL: "/suppliersuggestionpage"
        },
        {
            pageName: "ManageForms", pageTitle: "Manage Forms", pageURL: "/manageforms"
        },
        {
            pageName: "AddForms", pageTitle: "Add Forms", pageURL: "/addforms"
        },
        /*[12/15/22], PC_WW-552_FE_2, Dhevanesam R*/
        {
            pageName: "Forms", pageTitle: "Forms", pageURL: "/forms"
        },
        {
            pageName: "TrackingNumber", pageTitle: "TrackingNumber", pageURL: "/trackingnumberupd"
        },
        {
            pageName: "InteractiveDiagram", pageTitle: "InteractiveDiagram", pageURL: "/interactivediagram/"
        },
        {
            pageName: "BuildVersionHistory", pageTitle: "BuildVersionHistory", pageURL: "/buildversionhistory"
        },
        {
            pageName: "SrcNonCatalog", pageTitle: "SrcNonCatalog", pageURL: "/srcnoncatalog"
        },
        {
            pageName: "ReleaseNotesMaintenance", pageTitle: "ReleaseNotesMaintenance", pageURL: "/releasenotesmaintenance"
        },
        {
            pageName: "MobileInventoryManagement", pageTitle: "MobileInventoryManagement", pageURL: "/mobileinventorymanagement"
        },
        {
            pageName: "NonCatalogRequestEntry", pageTitle: "Non-Catalog Request", pageURL: "/walmartrfqentry"
        },
        {
            pageName: "PrintContainerBarCodeLabels", pageTitle: "Print Container Bar Code Labels", pageURL: "/printcntbarcode"
        },
        {
            pageName: "ContainerPacking", pageTitle: "Container Packing", pageURL: "/containerpacking"
        }, {
            pageName: "Equipments", pageTitle: "Equipments", pageURL: "/Equipments"
        },
        {
            pageName: "AcceptTransfer", pageTitle: "Accept Transfer", pageURL: "/AcceptTransfer"
        },
        {
            pageName: "FieldInventoryWorkBench", pageTitle: "Field Inventory Workbench", pageURL: "/FieldInventoryWorkbench"
        },
        {
            pageName: "AddVersion", pageTitle: "AddVersion", pageURL: "/addversioncomponent"
        },

    ],


    moduleNames: {
        Login: 1,
        ShoppingCart: 2,
        Menu: 3,
        Homepage: 4,
        OrderStatus: 5,
        FavOrder: 6,
        NonCatalog: 7,
        Searchpage: 8,
        Punchout: 9,
        Shopredirect: 10,
        Mobile: 11,
        OrderApproval: 12,
        UserProfile: 13,
        UserNotification: 14,
        ItemDetailNew: 15,
        ForgotPassword: 16,
        ChangePassword: 17,
        WaitingRequestorApproval: 18,
        FavItemMaintenance: 19,
        RequestorApproval: 20,
        PassThroughAuthe: 21,
        GetGraingerAvailability: 22,
        SupplierInCall: 23,
        ServiceChannel: 24,
        WarehouseAvailability: 25,
        Picking: 26,
        Receiving: 27,
        CycleCount: 28,
        ReconCycle: 29,
        ReplenishmentReview: 30,
        StockValueReport: 31,
        RMA: 32,
        CycleCountReport: 33,
        StockIssueReport: 34,
        BinLabel: 35,
        ProductReplen: 36,
        ItemMaintenanceA: 37,
        ASNApproval: 38,
        POWorkbench: 39,
        ExpressPutAway: 40,
        ManualStockAdjustment: 41,
        //[1/20/22, PC_IH_05, WW-320, Dhevanesam R]
        ItemHolds: 42,
        /*[2/24/22, PC_DP_05, Priyanka.D]*/
        DefaultPutAwayLocations: 43,
        BinToBinTransfer: 44,
        ReceivingReport: 45,
        TransactionReport: 46,
        OpenPOReport: 47,
        MaterialStorageLocr: 48,
        RTVItems: 49,
        ReprintPackingSlips: 50,
        Shipping: 51,
        /*[06/24/22, PC_WW-390_23]Priyanka D*/
        UserAnalytics: 52,
        STKIssuesCart: 57,
        LoadStageError: 59,
        TechVault: 60,
        AdvancedSupplierOrderEntry: 61,
        ManageForm: 62,
        TrackingNumberUpdate: 63,
        //[2/23/2022, WW-597 PC_597_01 ]-Pavithra R
        Receive_Item: 64,
        //[4/10/2023 ,WW-667 PC_667_01 ]-Pavithra R
        LabelPrinting: 65,
        BuildHistoryBL: 66,
        ReleaseNotesMaintenance: 67,
        MobileInventoryManagement: 68,
        WalmartNonCatalog: 69,
        ContainerBarCode: 70,
        containerPacking: 71,
        //WW-1163 IMPAQX Noncatalog -Vishwa S
        InteractiveDiagram: 72,
        EquipmentParts: 73,
        FieldInventoryWorkBench: 74,
        AcceptTransfer: 75
    },
    methodNames: {
        Login_Pageload: 1,
        Login_TokenUpdate: 2,
        ShoppingCart_Pageload: 3,
        Menu_BindUserMenu: 4,
        Homepage_Pageload: 5,
        OrderStatus_PageLoad: 6,
        FavOrder_Pageload: 7,
        OrderStatus_RetrieveOrderData: 8,
        FavOrder_RemoveFavOrder: 9,
        FavOrder_ReorderItems: 10,
        ShoppingCart_UpdateUserDesp: 11,
        ShoppingCart_btnSubmitNot_Click: 12,
        ShoppingCart_UpdateDueDate: 13,
        ShoppingCart_WriteToCartTable: 14,
        ShoppingCart_UpdateCatalog: 15,
        ShoppingCart_UpdateQtyValue: 16,
        ShoppingCart_UpdateUserEmp: 17,
        ShoppingCart_UpdateMexicanFields: 18,
        ShoppingCart_DeleteFromUserCart: 19,
        OrderStatus_ExportToExcel: 20,
        NonCatalog_PageLoad: 21,
        NonCatalog_CheckCatalog_Click: 22,
        NonCatalog_AttachFiles: 23,
        NonCatalog_DownloadFile: 24,
        NonCatalog_RemoveFile: 25,
        ShoppingCart_UpdateLineItemBYOrderDetails: 26,
        OrderStatus_ApprovalHistory: 27,
        ShoppingCart_AttachFiles: 28,
        ShoppingCart_DownloadFile: 29,
        ShoppingCart_RemoveFile: 30,
        NonCatalog_SaveNonCatalogEntry: 31,
        NonCatalog_QuickItemCheck: 32,
        NonCatalog_getcpdata: 33,
        TermsnConditionAccept: 34,
        Searchpage_Page_Load: 35,
        NonCatalog_SubmitQuickEntry: 36,
        Menu_GetMasterData: 37,
        ShoppingCart_GetAddToFavItemDetails: 38,
        ShoppingCart_updateFavs: 39,
        ShoppingCart_BtnSubmit_Click: 40,
        ShoppingCart_CartConfirmFile: 41,
        ShoppingCart_SubmitQuickEntry: 42,
        Menu_AddFavItemtoCart: 43,
        Menu_GetEnvironmentDetails: 44,
        Menu_GetCurrentFavPage: 45,
        Menu_InsertFavPage: 46,
        Menu_DeleteFavPage: 47,
        Menu_SearchSuggestions: 48,
        Punchout_PageLoad: 49,
        Punchout_LogoClick: 50,
        OrderStatus_ShipTo: 51,
        Shopredirect_AddPunchoutDatatoCart: 52,
        Mobile_GetConfigurations: 53,
        OrderApproval_PageLoad: 54,
        UserProfile_Page_Load: 55,
        UserProfile_radioUserType_SelectedIndexChanged: 56,
        UserProfile_rcbdropSelectUser_SelectedIndexChanged: 57,
        UserProfile_MainvndrID_TextChanged: 58,
        UserProfile_MultiSiteChk_CheckedChanged: 59,
        UserProfile_btnSave_Click: 60,
        UserProfile_tbStripUserDetails_TabClick: 61,
        UserProfile_ddlSDiUsers_SelectedIndexChanged: 62,
        UserProfile_btnSetBudAppr_Click: 63,
        UserProfile_btnSetReqAppr_Click: 64,
        UserProfile_btnSubmit_Click: 65,
        UserProfile_btnSubmitReqAppr_Click: 66,
        UserProfile_btnOrdStatEmailSubmit_Click: 67,
        UserProfile_btnSubmitPrefs_Click: 68,
        UserProfile_btnGribSubmit_Click: 69,
        UserProfile_btnZuseSubmit_Click: 70,
        UserProfile_btnTangoAddOtherUser_Click: 71,
        UserProfile_rblType_SelectedIndexChanged: 72,
        UserProfile_ddlUserRole_SelectedIndexChanged: 73,
        UserProfile_btnUserAccessSave_Click: 74,
        UserProfile_btnActivateAccount_Click: 75,
        UserProfile_btnInactivateAccount_Click: 76,
        UserProfile_btnEmplActivateAccount_Click: 77,
        UserProfile_btnEmplInactivateAccount_Click: 78,
        UserNotification_PagLoad: 79,
        UserNotification_imgArchive_Command: 80,
        UserNotification_FileDownload: 81,
        OrderApproval_ExportToExcel: 82,
        UserNotification_NotifyDetail: 83,
        OrderApproval_ApproveHeaderOrder: 84,
        OrderApproval_DeclineHeaderOrder: 85,
        ItemDetailNew_Page_Load: 86,
        ItemDetailNew_sdiTabStrip_TabClick: 87,
        ItemDetailNew_imgBtnAddToCart_Click: 88,
        ForgotPassword_CustomValidator2_ServerValidate: 89,
        ChangePassword_btn_Update_Pwd_Click: 90,
        WaitingRequestorApproval_Pageload: 91,
        WaitingRequestorApproval_ExportToExcel: 92,
        FavItemMaintenance_PageLoad: 93,
        FavItemMaintenance_UpdateFavItem: 94,
        FavItemMaintenance_DeleteFavItem: 95,
        OrderStatus_OrderDetail: 96,
        FavItemMaintenance_txtid_TextChanged: 97,
        FavItemMaintenance_InsertFavItem: 98,
        RequestorApproval_PageLoad: 99,
        RequestorApproval_ApproveClickEvent: 100,
        OrderStatus_btnSavePrefs_Click: 101,
        OrderStatus_ReorderItems: 102,
        RequestorApproval_ApproveSingleLineClickEvent: 103,
        RequestorApproval_DeclineClickEvent: 104,
        RequestorApproval_DeclineSingleLineClickEvent: 105,
        OrderStatus_PoDetails: 106,
        Searchpage_AddToCart_Click: 107,
        Searchpage_ProductCatalog: 108,
        ShoppingCart_UpdateLineLevelItem: 109,
        ShoppingCart_UpdateFieldLevelItem: 110,
        FavItemMaintenance_AddNonCatalogFavItem: 111,
        Mobile_SubmitOrder: 112,
        TermsnConditionAccept_Click: 113,
        ShoppingCart_btnCancel_Click: 116,
        UserProfile_SiteBased_ThirdParty: 117,
        Shopredirect_ReturnPunchoutXMLContents: 118,
        Shopredirect_AddPunchoutDatatoCartWithXML: 119,
        ServiceChannel_GetStoreData: 120,
        SupplierOrderEntry_PageLoad: 121,
        InsertSupplier_Entry: 122,
        Pickup_Vendor: 123,
        PassThroughAuthe_PassAutheInitialize: 124,
        GetOrderNum: 125,
        StoreRefreshDatetime: 126,
        getPreFilterData: 127,
        GetBOM: 128,
        GetReferenceSiteList: 129,
        GetTradeCategoryList: 130,
        GetGraingerAvailability: 131,
        GetPickingOrders: 132,
        UploadPickupOrder: 133,
        GetShipto: 134,
        GetStoreDataAsync: 135,
        ReceivingPageLoad: 136,
        getPODetails: 137,
        submitReceiving: 138,
        Token_Delete: 139,
        GetWarehouseAvailablity: 140,
        GetReqApprovalCount: 142,
        RequestorApproval_DeclineReason: 143,
        ShoppingCart_DeleteFavItem: 144,
        ShoppingCart_ZipCodeLatLong: 146,
        CycleCount_PageLoad: 147,
        CycleCount_UpdateQuantity: 148,
        CycleCount_CountedPageLoad: 151,
        GetFormDropDownValues: 152,
        ReconPage_Load: 153,
        Finalization_Click: 154,
        LoadRecon_Click: 155,
        Update_Click: 156,
        ExportToExcel: 157,
        GetSearchRecon: 158,
        FinalizeRecon: 159,
        LoadRecon: 160,
        ReplenishmentReview_Pageload: 161,
        ReplenishmentReview_VendorData: 162,
        ReplenishmentReview_GetData: 163,
        ReplenishmentReview_UpdateItem: 164,
        ReplenishmentReview_ExportToExcel: 165,
        ReplenishmentReview_ProcessReplen: 166,
        ReconGrid_Load: 167,
        ReplenishmentReview_OnStatusChange: 168,
        Stockvalue_PageLoad: 169,
        Stockvalue_GridDataLoad: 170,
        Stockvalue_ExportToExcel: 171,
        RMA_PageLoad: 174,
        RMA_SearchButtonClick: 175,
        RMA_SaveButtonClick: 176,
        RMA_ReasonSelect: 177,
        CycleCountReport_CCRptGridLoad: 178,
        CycleCountReport_ExportToExcel: 179,
        Stockvalue_Total: 180,
        CycleCountReport_Total: 181,
        StockIssue_GridLoad: 182,
        StockIssue_ExportTOExcel: 183,
        BinLabel_PageLoad: 184,
        BinLabel_GridLoad: 185,
        StockIssue_PageLoad: 186,
        StockIssue_Total: 187,
        ProductReplen_PageLoad: 188,
        ProductReplen_ItemDetail: 189,
        ProductReplen_AddtoCart: 190,
        ProductReplen_PlaceOrder: 191,
        ProductReplen_ItemUpdate: 192,
        ProductReplen_ItemDelete: 193,
        ItemMaintenanceA_PageLoad: 194,
        ItemMaintenanceA_SaveButtonClick: 195,
        GetASNData: 196,
        InsertASNData: 197,
        PrintPurchaseOrder: 198,
        ASN_Attachment: 199,
        ASN_DownloadAttachment: 200,
        ASN_RemoveAttachment: 201,
        POWorkbench_PageLoad: 202,
        POWorkbench_GridLoad: 203,
        POWorkbench_History: 204,
        POWorkbench_SaveClick: 205,
        POWorkbench_ExportToExcel: 206,
        ExpressPutAway_PageLoad: 208,
        ExpressPutAway_SaveItems: 209,
        ManualStockAdjustment_PageLoad: 210,
        ManualStockAdjustment_SearchItem: 211,
        ManualStockAdjustment_AdjConfSubmitClick: 212,
        //[2/2/2022, PC_OS_05, WW-350, Dhevanesam R]
        CancelRequest: 213,
        //[1/20/22, PC_IH_05, WW-320, Dhevanesam R]
        ItemHolds_PageLoad: 214,
        ItemHolds_btnSearch_Click: 215,
        ItemHolds_btnPutItmOnHld_Click: 216,
        ItemHolds_btnUpdate_Click: 217,
        /*[2/24/22, PC_DP_05, Priyanka.D]*/
        DefaultPutAway_Pageload: 218,
        DefaultPutAway_Search: 219,
        DefaultPutAway_AddNew: 220,
        DefaultPutAway_Save: 221,
        BinToBinTransfer_SearchItem: 222,
        BinToBinTransfer_TransSub: 223,
        OrderApproval_AddressSaveButtonClick: 224,
        ReceivingReport_PageLoad: 226,
        ReceivingReport_GoButtonClick: 227,
        TransactionReport_GoButtonClick: 229,
        GetOpenPODetails: 230,
        GetExportDetails: 231,
        GetVendorInfo: 232,
        RTVPageload: 237,
        RTVSaveLines: 238,
        //WBW - 11 Receiving Report - Excel Change - Deepthi N H
        ReceivingReportExportExcel: 239,
        //[02/25/22, WW - 316 , Dhevanesam R
        GetRecommendedItems: 228,
        ReprintPackingSlips_PickDate: 240,
        ReprintPackingSlips_Reprint: 241,
        MaterialStorageLocr_PageLoad: 233,
        MaterialStorageLocr_LoadArea: 234,
        MaterialStorageLocr_SearchBtnClick: 235,
        MaterialStorageLocr_AddOrUpdateLocation: 236,
        ReprintPackingSlips_ReportDownload: 237,
        //Shipping Fedex and Freight - Deepthi
        Shipping_PageLoad: 244,
        Shipping_AccessToken: 245,
        //WW-38 Need to add Description and Unit Of Measure (UOM) fields to Express Put Away page. UOM should be shown in all Transaction pages - Deepthi
        ExpressPutAway_SearchItem: 247,
        /*[03/16/22,WAL-721_PC_04,WAL-721], Priyanka D */
        ShoppingCart_ReorderChecker: 250,
        //Shipping Fedex and Freight - Deepthi
        Shipping_SubmitClick: 252,
        ShareFavOrder: 246,//WAL-714
        ShareFavItem: 243,
        UpdateFavorder: 251,
        GetSwingFormDetails: 253,
        UploadAlternativeItemImage: 255,
        Shipping_UpdateTransaction: 257,
        BindShipto: 258,
        DeleteMultipleFavItem: 259,//WW-419_PC_08 (5/25/2022) -Aparna
        //[05/10/22,WW-243-Cart Counter Updation, Priyanka D 
        Menu_GetCartCount: 260,
        RemoveMultipleOrder: 261, //WW-419_PC_08 (5/25/2022) -Aparna
        /*[05/18/22,WW-404_08], Priyanka D */
        ReprintPackingSlips_Pageload: 262,
        Shipping_PrintLabel: 263,
        UpdateRefSiteMaintenance: 264,
        AddRefSiteMaintenance: 265,
        /*[06/24/22, PC_WW-390_23]Priyanka D*/
        SendAnalytics: 254,
        STKIssuesCart_PageLoad: 267,
        STKIssuesCart_ItemSearch: 268,
        STKIssuesCart_Submit: 269,
        Shipping_WeighingScale: 270,
        TransactionReport_ExportToExcel: 272,
        LoadStageError_PageLoad: 274,
        LoadStageError_Detail: 275,
        LoadStageError_Save: 276,
        // Order Status Stored Procedure Integration Change - Deepthi
        OrderStatus_HeaderSP: 277,
        OrderStatus_LineLevelSP: 278,
        GetEncryptedCredentials: 172,
        ValidateToken: 280,
        AdvancedSupplierOrderEntry_PageLoad: 281,
        AdvancedSupplierOrderEntry_GetPDetails: 282,
        AdvancedSupplierOrderEntry_CreateNewPO: 283,
        /*'[10/04/22,WW-521_10-Rating Submission], Priyanka D */
        ShoppingCart_RatingSubmission: 284,
        GetHallLocations: 279,
        GetPostalHallLocations: 285,
        //[10/28/22], PC_WW-529_8, Dhevanesam R
        ChangeAssignto: 286,
        UserNotification_UnArchive: 288,
        CheckThirdPatryID: 289,
        //[12/15/22], PC_WW-552_FE_2, Dhevanesam R
        Searchpage_dynamicFormClick: 290,
        ManageForms_PageLoad: 291,
        ManageForms_SaveForm: 292,
        ManageForms_DeleteForm: 293,
        ManageForms_SaveFormName: 294,
        TrackUpdate_PageLoad: 295,
        TrackUpdate_SearchOrder: 296,
        TrackUpdate_UpdateTrackingNumber: 297,
        WaitingReq_ApproveOrDeclineOrder: 298,
        WaitingReq_UpdateDeclineReason: 299,
        ManageForms_SaveImg: 300,
        //[2/23/2022, WW-597 PC_597_01 ]-Pavithra R
        delivery_Ticket_Pdf: 301,
        MakePickupToDelivered: 303,//WW-644_PC_1 (3/6/2023) -Aparna 
        LabelPrintingPageLoad: 307,
        LabelGridDataBind: 308,
        PrintSelecteditemLabel: 309,
        ActiveFlagUpdate: 310,
        OrderApprovalLine_PageLoad: 311,
        GetReleaseNotesHistory: 313,
        GetCoreRetunDetails: 315,
        Reprint: 316,
        CreateShippingLabel: 314,
        getContactDetails: 316,
        ReleaseNotesMaintenance_PageLoad: 318,
        ReleaseNotesMaintenance_DeleteVersion: 319,
        ReleaseNotesMaintenance_Save: 320,
        ItemMaintenanceA_ValidateMfg: 321,//CPW-94_PC_01 (9/14/2023)-Aparna
        Mob_Inv_Pageload: 322,
        Mob_Inv_GetData: 323,
        Mob_Inv_SaveItem: 324,
        Mob_inv_StatusOnchange: 325,
        Mob_Inv_ProcessReplen: 326,
        Mob_Inv_ApproveAll: 327,
        Mutli_Attach_For_Form: 328,
        Trans_PageLoad: 329,
        GetSelectedCribRecords: 330,
        GetMfgNameSuggestions: 331,
        WalmartNonCatalog_Page_Load: 332,
        WalmartNonCatalog_SaveNonCatalogEntry: 333,
        WalmartNonCatalog_removecartItem: 334,
        WalmartNonCatalog_submitOrder: 335,
        WalmartNonCatalog_CancelOrder: 336,
        WalmartNonCatalog_UpdateLineLevelItem: 336,
        ZipcodeValidation: 337,
        //Google API -Zipcode validation WW-748/782 Pavitha [4/24/2024] 
        Mob_Inv_ExportToExcel: 338,
        BinGetLocation: 339,
        OrderStatus_ApprovalRemainder: 340,
        OrderStatus_ApproverList: 341,
        UserProfile_btnSetAltBudAppr_Click: 342,
        UserProfile_btnSubmitAltBudAppr_Click: 343,
        deleteMultiImage: 344,
        ManualStockAdjustment_reorderCheck: 345,
        ManualStockAdjustment_reorderSubmitClick: 346,
        Container_Packing_pageLoad: 348,
        Container_Packing_getChosenOrder: 349,
        Container_Packing_shippingClick: 350,
        ReplenishmentReview_GetOtherData: 351,
        //WW-1163 IMPAQX Noncatalog -Vishwa S
        Interactive_PageLoad: 352,
        ContainerBarCode_pageLoad: 353,
        ContainerBarCode_printLabel: 354,
        ContainerBarCode_displayPDF: 355,
        //WW-1216 Precart - Yuvarani K
        InsertReview: 359,
        ContainerBarCode_displayPDF: 355,
        //11/22/2024, WW-1046 Start a return -Vishwa S
        SendMailForRMAReturn: 356,
        EquipmentParts_PageLoad: 358,
        getLoginOutageData: 362,
        OrderStatus_GetNotes: 360,
        FieldInventory_PageLoad: 381,
        FieldInventory_GetMoreDetail: 365,
        FieldInventory_GetData: 366,
        BinToBinTransfer_TruckPageLoad: 367,
        STKIssuesCart_SaveStockItemCart: 368,
        STKIssuesCart_DeleteAction: 369,
        STKIssuesCart_UpdateAction: 370,
        BinToBinTransfer_SaveTransferCart: 373,
        BinToBinTransfer_updateTransferAction: 371,
        STKIssuesCart_DeleteUnavailableItems: 372,
        BinToBinTransfer_DeleteUnavailableItems:374,
        BinToBinTransfer_TransferSubmit: 375,
        AcceptTransfer_PageLoad: 379,
        AcceptTransfer_UpdateTransfer: 380

    }
}

const ConvertToEst = (dateString) => {
    // First, split the date string to extract date and time components
    const [datePart, timePart] = dateString.split('T');

    // Further split the date and time to individual elements
    const [year, month, day] = datePart.split('-');
    let [hour, minute] = timePart.split(':');

    // Convert the hour from 24-hour format to 12-hour format and determine AM/PM
    hour = parseInt(hour, 10);
    const period = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12; // Convert to 12-hour format and handle midnight (0 hour)

    // Format the final desired output
    const formattedDate = `${hour}:${minute} ${period} EST ${month}/${day}/${year}`;
    return formattedDate;
};

let getAPIURL = async () => {

    let response = "";
    let cachedURL = sessionStorage.getItem("serviceURL");
    if (!cachedURL || cachedURL == "") {
        response = await $.ajax({
            type: "GET",
            url: SDIConstants.localService
        });
        sessionStorage.setItem("serviceURL", response);
    } else {
        response = sessionStorage.getItem("serviceURL");
    }
    return response;

}
export default SDIConstants;
export { getAPIURL, ConvertToEst };

//Session Parameter names
 //"Session_UserID"
 //"Session_WEBSITEID"
 //"Session_SITE_CONTACTS" 
 //"Session_AMAZONSEARCH" 
 //"Session_USERTYPE"  
 //"Session_BUSUNIT" 
 //"Session_SITEID" 
 //"Session_USERNAME" 
 //"Session_EMAIL" 
 //"Session_PHONE" 
 //"Session_CUSTID" 
 //"Session_PRODVIEW" 
 //"Session_ACTIVEUSERS" 
 //"Session_CONAME" 
 //"Session_SDICAT" 
 //"Session_PARTLIST" 
 //"Session_SHIPTO_DEFAULT" 
 //"Session_ISAShipToID" 
 //"Session_CARTCHGCDREQ" 
 //"Session_CARTWOREQ" 
 //"Session_CARTWO_CHGCDREQ" 
 //"Session_CC_VALIDATE_WO" 
 //"Session_ISAProdPriceREQ" 
 //"Session_ISAPriceBlock" 
 //"Session_ShowPrice" 
 //"Session_IsSigPadOrdDispatch" 
 //"Session_IsSigPadStkIssue" 
 //"Session_ISACstVendor" 
 //"Session_ISACstPrice" 
 //"Session_ISAProFormaFlag" 
 //"Session_ISAQlikID" 
 //"Session_ISACrossSiteAcc" 
 //"Session_ISABudgetaryLimit" 
 //"Session_USESOLRSEARCH" 
 //"Session_ORGINSITE" 
 //"Session_MULTISITEUSER" 
 //"Session_ClientLogoImagePath" 
 //"Session_DEFAULTPAGE" 
 //"Session_ROLENUM" 
 //"Session_PROD_DESCPREFERENCE" 
 //"Session_TESTMODE" 
 //"Session_SITEEMAIL" 
 //"Session_CplusDbSQL" 
 //"Session_CplusDB" 
 //"Session_SITEPREFIX" 
 //"Session_ORDERPREFIX" 
 //"Session_SITELANG" 
 //"Session_UserTicketAssign" 
 //"Session_SITEBU" 
 //"Session_LBLPRT" 
 //"Session_OROPUNCHOUTFLAG" 
 //"Session_ISAShpdocRcv" 
 //"Session_SEARCH3M" 
 //"Session_SEARCHORONASCO" 
 //"Session_SEARCHCAPP" 
 //"Session_SEARCHMSC" 
 //"Session_SEARCHIMP" 
 //"Session_SEARCHSTAUFFER" 
 //"Session_CATLTREEHLDFLAG" 
 //"Session_CARTTAXEXMPTFLAG" 
 //"Session_APPRTYPE" 
 //"Session_BUDGETFLG" 
 //"Session_NSTKONLY" 
 //"Session_EmpChgCd" 
 //"Session_RecvDate" 
 //"Session_COMPANYID" 
 //"Session_ITEMMODE" 
 //"Session_SHOPPAGE" 
 //"Session_LPPFLAG" 
 //"Session_PUNCHOUT" 
 //"Session_PWDays21" 
 //"Session_MoblPick1" 
 //"Session_TrackDBType" 
 //"Session_TrackDBGUID" 
 //"Session_TrackDBUser" 
 //"Session_TrackDBPassword" 
 //"Session_TrackDBCust" 
 //"Session_RecvBarCodePrint" 
 //"Session_ValidateWorkOrder" 
 //"Session_IsaKitPrinting" 
 //"Session_IsaCustintApprvl" 
 //"Session_ApprovalTypeHL" 
 //"Session_RFQONLYSITE" 
 //"Session_BypassReqstrAppr" 
 //"Session_SmallSite" 
 //"Session_MobIssuing" 
 //"Session_DeptIdN1" 
 //"Session_ShowPriceInRecv" 
 //"Session_IsaSdixchApprvl" 
 //"Session_RFApproveLikeAscend" 
 //"Session_ZEUSNOCATALOGSITE" 
 //"Session_ZEUS_SITE" 
 //"Session_CREDITCARDPROCSite" 
 //"Session_MANORDNO" 
 //"Session_ORDLNRENUM" 
 //"Session_RFQSite" 
 //"Session_SDIEMP" 
 //"Session_STOCKREQPRIV" 
 //"Session_NONSTCKREQPRIV" 
 //"Session_NEWITEMPRIV" 
 //"Session_MODITEMPRIV" 
 //"Session_AGENTUSERBU" 
 //"Session_AGENTUSERID" 
 //"Session_ISOL" 
 //"Session_CatalogdtTop" 
 //"Session_Trackvalue" 
 //"Session_SDITRACKUSRNAME" 
 //"Session_SDITRACKPWD" 
 //"Session_TCKTDEPT" 
 //"Session_ISA_USER_ID" 
//Session_THIRDPARTY_COMP_ID
 //Session_PageName